import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useViewSize } from '@bubble-ui/hook-use-view-size';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import View, { ViewStyles } from '@bubble-ui/primitive-view';
import { useAnimationControl } from '@bubble-ui/provider-animation-control';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getContentIds } from './getIds';
var RadioOptionContent = _ref => {
  var {
    id,
    children,
    disableAnimation: disableAnimationProp,
    onAnimationEnd,
    isExpanded
  } = _ref;
  var ids = getContentIds(id);
  var [innerWrapperViewProps, {
    height: innerWrapperHeight
  }] = useViewSize();
  var {
    disableAnimations: disableAnimationsContext
  } = useAnimationControl();
  var disableAnimation = disableAnimationProp || disableAnimationsContext;
  var {
    rootStyle
  } = useStyleSheet(RadioOptionContent, getDefaultStyleSheet, {
    isExpanded
  });
  return disableAnimation ? /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    style: rootStyle
  }, isExpanded ? {} : {
    'aria-hidden': true
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.innerWrapper
  }, children)) : /*#__PURE__*/React.createElement("div", _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    onTransitionEnd: e => {
      if (e.propertyName === 'height') {
        onAnimationEnd && onAnimationEnd();
      }
    },
    style: _objectSpread(_objectSpread({}, ViewStyles), {}, {
      overflow: 'hidden',
      height: isExpanded ? innerWrapperHeight : 0,
      transition: 'height .5s'
    })
  }, isExpanded ? {} : {
    'aria-hidden': 'true'
  }), /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.innerWrapper
  }, innerWrapperViewProps), children));
};
RadioOptionContent.displayName = 'RadioOptionContent';
export { RadioOptionContent };
//# sourceMappingURL=index.js.map